<template lang="html">
  <div class="session"></div>
</template>

<script>
import { EventBus } from './EventBus';

export default {
  data () {
    return {
      // Quiz data
      quiz: {
        gender: null,
        name: '',
        surname: '',
        date_of_birth: '1970-01-01'
      },
      // Session information
      info: {},
      // Stripe API instance
      stripeAPI: null,
      updateQueue: [],
      loading: false,
      // Stripe data required for appstore stripe-checkout-v2.js
      stripe: {},
    }
  },
  comptuted: {
    hasUserInfo() {
      return !!this.info.user
    },
  },
  methods: {
    reload(then) {
      console.log('Reloading session')
      console.trace()

      if (this.loading) {
        console.warn('Already loading')
        return false
      }
      this.loading = true

      let sessionURL = this.$parent.sessionUrl;
      const planCode = new URLSearchParams(window.location.search).get(
        "plan_code"
      )
      if (planCode) {
        const glue = sessionURL.indexOf('?') > 0 ? '&' : '?';
        sessionURL = `${sessionURL}${glue}plan_code=${planCode}`
      }

      fetch(sessionURL)
        .then(r => { return r.json() })
        .then(data => {
          this.info = data.session
          this.stripeAPI = Stripe(this.info.stripe.publishable_key)

          if (typeof(checkStatus) == 'function') {
            checkStatus(this.stripeAPI, ['name', 'email', 'phone', 'city', 'address']).then(result => {
              if (result) {
                const successPageURL = '/customer/download-app/'
                window.location.replace(`${successPageURL}${window.location.search}`)
              }

              if (then) then(data)
            })
          } else {
            if (then) then(data)
          }

          this.loading = false
        })
    },
    getPriceCents() {
      return parseFloat(this.info.plan.price) * 100
    },
    setUserInfo(userInfo) {
      var formData = new FormData()
      userInfo.first_name && formData.append('first_name', userInfo.first_name)
      userInfo.last_name && formData.append('last_name', userInfo.last_name)
      userInfo.email && formData.append('email', userInfo.email)

      fetch('/api/user/info/', {
        method: 'POST',
        body: formData
      }).then(r => {
        let data = r.json()

        if (r.status == 400) {
          this.errors = data.errors
        }

        return data
      }).then(data => {
        if (data.status ==  'ok') {

          if (!this.info.user) {
            this.info.user = {}
          }

          ['first_name', 'last_name', 'email'].forEach((key, i) => {
            if (userInfo[key]) {
              this.info.user[key] = userInfo[key]
            }
          })

          EventBus.$emit('user-info-saved', userInfo)
        } else {
          EventBus.$emit('user-info-saved', false)
        }
      })
    },

    setUserEmail(email) {
        if (email) {
          this.info.user.email = email;
        }
    },

    getUserInfo() {
      if (this.updateQueue.length == 0) {
        let time = new Date().getTime()
        this.updateQueue.push(time)

        this.emitUserInfo()
      }
    },

    emitUserInfo() {
      let doEmitUserData = () => {
        let time = new Date().getTime()
        this.updateQueue = this.updateQueue.filter((x) => x < time)
        EventBus.$emit('user-info', this.info.user)
      }

      if (this.hasUserInfo) {
        doEmitUserData()
      } else {
        this.reload((data) => {
          doEmitUserData()
        })
      }
    },
  },
  mounted () {
    EventBus.$emit('show-preloader')

    this.reload((data) => {
      EventBus.$emit('hide-preloader')

      if (this.info.user) {
        EventBus.$emit('user-info', this.info.user)
      }

      if (this.info.subscriptions?.length) {
        EventBus.$emit('show-user-subscriptions', this.info.subscriptions)
      }
    })
  },
  created() {
    EventBus.$on('get-user-info', this.getUserInfo)
    EventBus.$on('set-user-info', this.setUserInfo)
  },
  destroyed() {
    EventBus.$off('get-user-info', this.getUserInfo)
    EventBus.$off('set-user-info', this.setUserInfo)
  },
}
</script>

<style lang="sass" scoped>
.session
  height: 0px
</style>
